// كل ما يراه المستخدم بالعربية؛ رموز الـAPI تبقى إنجليزية (نفس نمط settlementLabels/paymentLabels).
// لا يوجد في هذا الملف — ولا في أي ملف من ملفات الوحدة — أي ذكر لبيانات الجهاز: قرار المالك D-2
// رفضها رفضًا كاملًا في الواجهة.
import type {
  AttendanceAnomaly, Compliance, DayClassification, EventValidity, LeaveStatus, RecordStatus,
} from '../lib/api.ts';

export const RECORD_STATUS_AR: Record<RecordStatus, string> = {
  ON_LEAVE: 'إجازة معتمدة',
  NOT_STARTED: 'لم يبدأ بعد',
  IN_PROGRESS: 'داخل الدوام',
  RECORDED: 'مُسجَّل',
  MISSING_CHECK_IN: 'حضور غير مُسجَّل',
  MISSING_CHECK_OUT: 'انصراف غير مُسجَّل',
  ABSENT: 'غياب',
};

export const RECORD_STATUS_TONE: Record<RecordStatus, string> = {
  ON_LEAVE: 'bg-brand-50 text-brand-700',
  NOT_STARTED: 'bg-slate-100 text-ink-700',
  IN_PROGRESS: 'bg-amber-50 text-amber-800',
  RECORDED: 'bg-emerald-50 text-emerald-800',
  MISSING_CHECK_IN: 'bg-rose-50 text-rose-700',
  MISSING_CHECK_OUT: 'bg-rose-50 text-rose-700',
  ABSENT: 'bg-rose-100 text-rose-800',
};

export const COMPLIANCE_AR: Record<Compliance, string> = {
  COMPLETE: 'مكتمل',
  SHORT: 'أقل من المطلوب',
  UNDETERMINED: 'غير محدَّد',
  NOT_APPLICABLE: 'لا ينطبق',
};

export const ANOMALY_AR: Record<AttendanceAnomaly, string> = {
  WORKED_WHILE_ON_LEAVE: 'عمل في يوم إجازة معتمدة',
  MISSING_LOCATION: 'موقع غير متاح',
  MULTIPLE_UNMATCHED_EVENTS: 'أحداث غير مقترنة',
};

export const LEAVE_STATUS_AR: Record<LeaveStatus, string> = {
  PENDING: 'معلّقة',
  APPROVED: 'معتمدة',
  REJECTED: 'مرفوضة',
  CANCELLED: 'ملغاة',
};

export const LEAVE_STATUS_TONE: Record<LeaveStatus, string> = {
  PENDING: 'bg-amber-100 text-amber-900',
  APPROVED: 'bg-emerald-50 text-emerald-800',
  REJECTED: 'bg-rose-50 text-rose-700',
  CANCELLED: 'bg-slate-100 text-ink-500',
};

export const CLASSIFICATION_AR: Record<DayClassification, string> = {
  ABSENT: 'غياب',
  MISSING_CHECK_IN: 'حضور غير مُسجَّل',
  LEAVE: 'إجازة (بدون خصم)',
};

export const VALIDITY_AR: Record<EventValidity, string> = {
  VALID: 'سليم',
  INVALID: 'مُلغى',
};

export const KIND_AR = { CHECK_IN: 'حضور', CHECK_OUT: 'انصراف' } as const;

/** أيام الأسبوع بترقيم ISO (1 = الاثنين) كما تخزّنها work_schedules.workdays. */
export const WEEKDAYS_AR: { code: number; ar: string }[] = [
  { code: 6, ar: 'السبت' }, { code: 7, ar: 'الأحد' }, { code: 1, ar: 'الاثنين' },
  { code: 2, ar: 'الثلاثاء' }, { code: 3, ar: 'الأربعاء' }, { code: 4, ar: 'الخميس' }, { code: 5, ar: 'الجمعة' },
];
export const weekdaysAr = (days: number[]): string =>
  days.length === 0 ? '—' : WEEKDAYS_AR.filter(d => days.includes(d.code)).map(d => d.ar).join('، ');

export const SCHEDULE_KIND_AR = { FIXED: 'ثابت', FLEXIBLE: 'مرن' } as const;
